export default {
  en: {
    name: 'Создание блокчейн паспорта для ИСП "Заря"',
    desc: "Global registration service in the Ethereum Blockchain.",
  },
  ru: {
    name: 'Создание блокчейн паспорта для ИСП "Заря"',
    desc: "Сервис глобальной регистрации в Ethereum Blockchain.",
  },
  link: { name: "passport" },
  target: false,
  img: require("./logo.png"),
  by: [
    {
      link: "https://airalab.org/",
      label: "Airalab",
    },
  ],
  token: {
    address: "0x2a9688d4FfD94FE6C4447f60B7b25BE0a1ab87b4",
    name: "Russian Ruble (RUB)",
  },
  disabled: false,
};
